import { Component, Input } from "@angular/core";
import { IonModal } from "@ionic/angular";

import { NavigationService } from "@core/services/navigation/navigation.service";
import { Product } from "@shared/models/products.model";

@Component({
    selector: 'app-salary-or-pension-transfer',
    templateUrl: 'salary-or-pension-transfer.component.html',
    styleUrls: ['salary-or-pension-transfer.component.scss'],
    standalone: false
})
export class SalaryOrPensionTransferComponent {
  @Input() modal: IonModal;
  @Input() product: Product;

  constructor(private navigationService: NavigationService) {}

  chooseSalaryOrPension(option: 'salary' | 'pension') {
    if (option === 'pension') {
      this.navigationService.push('/pension-transfer');
      this.modal.dismiss();
    } else {
      this.navigationService.push('/salary-transfer', {
        queryParams: {
          productId: this.product.id,
          cardNumber: this.product.cardNumber
        }});
      this.modal.dismiss();
    }
  }
}
